import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'
import merge from 'deepmerge'
import { compactAndFilter } from '@/utils'

const module = 'boardtypes'
let doc = {
  list: {
    name: 'Categories',
    headers: [
      { label: 'Nom', value: 'name' },
      { label: 'Impression', value: 'print_type.name' },
      { label: 'Surface (m2)', value: 'surface', align: 'right' },
    ],
    actions: [
      { icon: 'add', isFlat: false, scope: ['boardtypes.create'], dispatch: `${module}/openForm` },
      { icon: 'search', isFlat: true, dispatch: `${module}/openSearch` },
    ],
    dataActions: [
      { icon: 'visibility', dispatch: `${module}/goTo` },
      { icon: 'pie_chart', context: {field: 'board_type_id'}, dispatch: `tenancy/getTenancy` },
    ],
    search: [
      { label: 'Nom', type: 'text', name: 'name' },
      { label: 'Impression', type: 'list', from: 'name', name: 'print_type_id', source: 'printtypes' },
    ],
  },

  form: {
    name: 'Categorie',
    fields: [
      { label: 'Nom', type: 'text', name: 'name' },
      { label: 'Description', type: 'text', name: 'description' },
      { label: 'Hauteur (cm)', type: 'text', name: 'height' },
      { label: 'Largeur (cm)', type: 'text', name: 'width' },
      { label: 'Impression', type: 'list', from: 'name', name: 'print_type_id', source: 'printtypes' },
    ],
    actions: [
      { icon: 'save', filter: {edit: true}, scope: ['boardtypes.update'], dispatch: `${module}/update` },
      { icon: 'delete', scope: ['boardtypes.update'], isFlat: true, dispatch: `${module}/delete` },
    ],
    relations: [
      {
        name: 'Panneaux',
        source: 'boards',
        headers: [
          { label: 'Adresse', value: 'adress' },
          { label: 'Statut', value: 'status.name' },
        ],
        dispatch: 'getBoards',
        dataActions: [
          { icon: 'visibility', isFlat: false, dispatch: `boards/goTo` },
        ],
      },
    ],
  },

  params: {
    fetchAll: {include: 'print_type'},
    fetchOne: {include: 'print_type'},
  },
}

const base = crudmaker(module, apiClient, doc)

const custom = {
  actions: {
    getBoards: ({ commit }, payload) => {
      commit('SET_LOADING', true)
      const { context, data } = payload
      commit('boards/LIST_REQUEST', payload, {root: true})
      let compacted = compactAndFilter(data)
      let params = {
        ...compacted,
        board_type_id: context.id,
        include: 'district.city.region,status',
      }
      apiClient.fetchCustom('boards', `boards`, params)
        .then(data => {
          commit('boards/LIST_SUCCESS', data, {root: true})
          commit('SET_LOADING', false)
        })
        .catch(error => {
          console.log(error)
          commit('boards/LIST_ERROR', error, {root: true})
          commit('SET_LOADING', false)
        })
    },
  },
}

export default merge(base, custom)
